<template>
    <div>
        <slot name="description">
            <p>Schedule Invoice Retry allows you to set multiple retries for subscriptions that fail to bill successfully, and define whether to cancel the subscription after the last attempt. You can even schedule discounts or partial payments.</p>
        </slot>
        <div class="divider divider-tile-content"></div>
        <h3 class="stack-m">Retry Attempts</h3>
        <slot name="table-description">
            <p class="stack-m">If a scheduled billing attempt fails, Rebilly will retry according to the following schedule:</p>
        </slot>
        <div v-if="hasAttempts">
            <table class="table">
                <colgroup>
                    <col style="width:50px;">
                    <col>
                    <!--<col width="50%">-->
                    <col style="width:50px;">
                </colgroup>
                <thead>
                <tr>
                    <th>Order</th>
                    <th>Schedule type</th>
                    <!--<th>Payment Adjustment</th>-->
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(attempt, index) in attempts">
                    <td>
                        <h2>{{ index + 1 }}</h2>
                    </td>
                    <td>
                        <slot
                            name="attempt"
                            :attempt="attempt"
                            :index="index"
                            :formatter="formatScheduleTypeDropDownLabel"/>
                    </td>
                    <!--<td>-->
                    <!--<define-payment-view-->
                    <!--:payment-instruction="attempt.paymentInstruction"-->
                    <!--:validate="$v.action.attempts[index].paymentInstruction"-->
                    <!--@update="data => updatePayment(index, data)"/>-->
                    <!--</td>-->
                    <td>
                        <v-icon-button type="basic" @click="deleteAttempt(index)">
                            <v-icon icon="trash"/>
                        </v-icon-button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div>
            <div class="divider no-margin-top"></div>
            <r-button type="link" @click="addAttempt">Add Attempt</r-button>
        </div>
        <div class="divider divider-tile-content"></div>
        <h3 class="stack-m">After Each Attempt</h3>
        <p class="stack-m">You may wish to push the renewal time into the future according to your plan schedule after each retry attempt. Otherwise the next rebill may occur while you are still within the retry schedule of the current rebill.</p>
        <slot name="after-each-attempt"/>
        <div class="divider divider-tile-content"></div>
        <h3 class="stack-m">After the Last Failed Attempt</h3>
        <p class="stack-m">If all of the retry attempts fail you can choose between doing nothing or canceling the subscription.</p>
        <slot name="after-last-attempt"/>
        <slot name="optional-footer"/>
    </div>
</template>

<script>
    import {vIconButton, vIcon} from '@/components/form';

    export default {
        name: 'schedule-invoice-body',
        components: {
            vIconButton,
            vIcon,
        },
        props: {
            attempts: Array,
        },
        computed: {
            hasAttempts() {
                return (this.attempts || []).length > 0;
            },
        },
        methods: {
            deleteAttempt(index) {
                this.$emit('delete-attempt', index);
            },
            addAttempt() {
                this.$emit('add-attempt');
            },
            formatScheduleTypeDropDownLabel({value, formatter}) {
                return `Retry ${formatter({value})}`;
            },
        },
    };
</script>
